<script setup lang="ts">
import VdIcon from "./VdIcon.vue";
import { brand } from "../brand";
import { isDarkTheme, themeToggleLabel, toggleTheme } from "../theme";
</script>

<template>
  <button
    v-if="brand.id === 'vkusnodomoy'"
    type="button"
    class="vd-iconbtn-neutral shrink-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-vd-brand"
    :aria-label="themeToggleLabel"
    :title="themeToggleLabel"
    :aria-pressed="isDarkTheme"
    @click="toggleTheme"
  >
    <VdIcon :name="isDarkTheme ? 'sun' : 'moon'" :size="19" />
  </button>
</template>
